/**
 * Fibre-G Precision Nutrition - Core Theme Interactions
 */
document.addEventListener('DOMContentLoaded', () => {
  // Sticky Header Scroll State
  const header = document.querySelector('.fibreg-header');
  if (header) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // Mobile Navigation Drawer Toggle
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', !isExpanded);
      mobileMenu.classList.toggle('active');
    });
  }

  // FAQ Accordions
  const faqTriggers = document.querySelectorAll('.faq-trigger');
  faqTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.faq-item');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      
      // Close other FAQs in the same container if desired
      const container = trigger.closest('.faq-container');
      if (container) {
        container.querySelectorAll('.faq-item').forEach((sibling) => {
          if (sibling !== item) {
            sibling.classList.remove('active');
            const siblingBtn = sibling.querySelector('.faq-trigger');
            if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      item.classList.toggle('active', !isExpanded);
      trigger.setAttribute('aria-expanded', !isExpanded);
    });
  });

  // Tab Panes (e.g., Pricing Formulations: Original vs Pro)
  const tabContainers = document.querySelectorAll('[data-tabs-container]');
  tabContainers.forEach((container) => {
    const tabButtons = container.querySelectorAll('[data-tab-target]');
    const tabPanes = container.querySelectorAll('[data-tab-pane]');

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const targetKey = btn.getAttribute('data-tab-target');

        tabButtons.forEach((b) => {
          const isSelected = b === btn;
          b.setAttribute('aria-selected', isSelected);
          if (isSelected) {
            b.style.backgroundColor = '#ffffff';
            b.style.color = 'var(--color-primary)';
            b.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
          } else {
            b.style.backgroundColor = 'transparent';
            b.style.color = 'var(--color-text-secondary)';
            b.style.boxShadow = 'none';
          }
        });

        tabPanes.forEach((pane) => {
          if (pane.getAttribute('data-tab-pane') === targetKey) {
            pane.style.display = 'grid';
          } else {
            pane.style.display = 'none';
          }
        });
      });
    });
  });
});
